import React, { ReactNode } from 'react';
import { cn } from '../../../utils';

export const RightCard: React.FC<{
  children: ReactNode;
  /**
   * Extra classes on the inner content column - e.g. bottom padding so the
   * last row keeps clear of the viewport edge when the form is taller than
   * the screen and the page scrolls. Defaults to nothing extra, so every
   * existing caller keeps today's exact layout.
   */
  className?: string;
}> = ({ children, className }) => {
  return (
    <div className="lg:p-8">
      <div
        className={cn(
          'mx-auto flex w-[90vw] max-w-[90vw]  flex-col justify-center space-y-6 sm:w-96 sm:max-w-sm',
          className
        )}
      >
        {children}
      </div>
    </div>
  );
};
